import type {PreviewConfiguration} from 'schema/types';
import {Dewey} from 'schemas/renderers';
import {WorkPrizes} from 'schemas/renderers/WorkPrizes';

export const workPreviewConfig: PreviewConfiguration = {
  layout: {
    linkedValuesByRoles: true,
    groups: {
      info: {
        direction: 'horizontal',
      },
    },
  },
  partValueRenderers: {
    dewey: Dewey,
    prizes: WorkPrizes,
  },
};
